const BASEDIR = "../";

const INFO = {
	main: {
		title: "Emmanuel Mmanda | Porfolio",
		name: "Emmanuel Mmanda",
		email: "luneya17@gmail.com",
		logo: BASEDIR + "logo.png",
	},

	socials: {
		twitter: "https://twitter.com/immaginativetz",
		github: "https://github.com/EmmanuelMmanda",
		linkedin: "https://www.linkedin.com/in/emmanuel-mmanda-4a727524b/",
		instagram: "https://instagram.com/hourlycodez",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
		whatsapp:
			"https://wa.me/+255627472950/?text=Hello Emmanuel, Lets connect.",
	},

	homepage: {
		title: "I'm a Software Developer",
		description:
			"I am a software developer with experience in Javascript and Python. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Emmanuel Mmanda, I live in Tanzania, where I design the future.",
		description:
			"I've worked on a variety of projects and multiple programming languages [Javascript, python and PHP] over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Tanzania Geo-Data API",
			description:
				"An Geography data API for Regions,Wards and Streets in Tanzania mainland",
			logo: "https://i.imgur.com/4aBDglJ.png",
			linkText: "View Project",
			link: "https://github.com/EmmanuelMmanda/Tanzania-GeoLocation-API-for-regions--districts-and-wards",
			tags: ["python / ", "django / ", "DRF / ", "vercel / "],
		},

		{
			title: "Voting System using USSD and SMS - DRF API",
			description:
				"An implementation of a Voting System API in Django rest Framework , with USSD and SMS Integration from Africas Talking Aggregator,",
			logo: "https://i.imgur.com/fvO3DKF.png",
			linkText: "View Project",
			link: "https://github.com/EmmanuelMmanda/USSD-and-SMS-Voting-System--DRF-API",
			tags: ["Africas Talking / ", "django / ", "DRF / ", "GCP / "],
		},

		{
			title: "Foody React App",
			description:
				"A simple Food Ordering Web Application Using React Js - Helps to  Understanfing basic react concepts of React Context , Hooks and props.",
			logo: "https://raw.githubusercontent.com/EmmanuelMmanda/A-Food-Ordering-Web-Application-Using-React-Js--/main/src/Assets/food%20order.png",
			linkText: "View Project",
			link: "https://github.com/EmmanuelMmanda/A-Food-Ordering-Web-Application-Using-React-Js--",
			tags: ["React / ", "Firebase / ", "Github Pages / ", "Live Demo"],
		},
		{
			title: "Todo App with API Integration",
			description:
				"An online todo application teaser , using React(Vite) for frontend and the provided API from HISP DHIS 2",
			logo: "https://i.imgur.com/gVFXdZX.png",
			linkText: "View Project",
			link: "https://github.com/EmmanuelMmanda/hisp-todo-teaser",
			tags: ["Vite / ", "React / ", "Digital Ocean / "],
		},

		{
			title: "Herbal information System ",
			description:
				"A Herbal information system for linking patients and Traditional Medicine Providers",
			logo: "https://raw.githubusercontent.com/EmmanuelMmanda/PHP-Herbal-Information-System/master/images/git.PNG",
			linkText: "View Project",
			link: "https://github.com/EmmanuelMmanda/PHP-Herbal-Information-System",
			tags: ["PHP / ", "Github / "],
		},
		{
			title: "Mobile First Design",
			description:
				"A mobile first web design method with sidebar and theme toggle dark light theme, Help to understanding theming using only HTML and CSS",
			logo: "https://i.imgur.com/dlMHGWS.jpg",
			linkText: "View Project",
			link: "https://github.com/EmmanuelMmanda/mobile-first-design-with-dark-theme-and-sidebar",
			tags: ["HTML / ", "CSS / ", "Github Pages / "],
		},
		{
			title: "Maternal Information System with SMS Integration",
			description:
				"A Maternity system to keep track of during maternity period in a health Facility. Project made with PHP - Intergrated with SMS functionality,",
			logo: "https://raw.githubusercontent.com/EmmanuelMmanda/Maternity-System-with-SMS-API-Intergration/master/maternalsgit.PNG",
			linkText: "View Project",
			link: "https://github.com/EmmanuelMmanda/Maternity-System-with-SMS-API-Intergration",
			tags: ["Beem Africa / ", "PHP / ", "Github / "],
		},
	],
	works: [
		{
			logo: "https://i.imgur.com/4gIXRVA.png",
			alt: "work-logo",
			workTitle: "Fléx - CITS",
			workSubtitle: "Fulltime: Software Engineer",
			workDuration: "Sept 2023 - Present",
		},
		{
			logo: "https://i.imgur.com/i50cId4.png",
			alt: "work-logo",
			workTitle: "Fléx - CITS",
			workSubtitle: "Intern: Software Developer",
			workDuration: "Jul 2023 - Aug 2023",
		},
		{
			logo: "https://i.imgur.com/RqnjF21.jpg",
			alt: "work-logo",
			workTitle: "Ardhi University",
			workSubtitle: "Bsc.Information System Management",
			workDuration: "2020 - Jul 2023",
		},
		{
			logo: BASEDIR + "logo.png",
			alt: "work-logo",
			workTitle: "Freelencer",
			workSubtitle: "Software Development",
			workDuration: "2020 - Present",
		},
	],
};

export default INFO;
